// extracted by mini-css-extract-plugin
export default {"PanelBody":"RequireAuth_PanelBody__DYUSx"};